import { FeatureFlag, useFeatureFlag } from "../contexts/launchDarklyContext";

/**
 * Whether the live document-processing view (the floating status toast + its
 * expanded modal) is enabled for the current user.
 *
 * Single source of truth shared by the view itself and by upload flows that
 * suppress their redundant "uploaded successfully…" toast when the live view
 * already conveys processing status — so the two never drift out of sync.
 *
 * Gated by the `live-document-processing` LaunchDarkly flag. Targeting (e.g.
 * Midship-only workspaces during rollout) is configured in the LaunchDarkly
 * dashboard, not in code. Fails closed until flags resolve.
 */
export function useLiveDocumentProcessingEnabled(): boolean {
  return useFeatureFlag(FeatureFlag.liveDocumentProcessing);
}
